const JsLoading = function() {

    const _elmLOading = $(".jsLoadingContent");

    const showLoading = (el) => {
        el.parent().find(_elmLOading).fadeIn(100, function(){
            $(this).removeClass('motion-out').addClass('motion-in')
        });
        // _elmLOading.removeClass('motion-in');
    }
    
    const hideLoading = (el) => {
        el.parent().find(_elmLOading).removeClass('motion-in').addClass('motion-out');
        //el.parent().find(_elmLOading).fadeOut(200);
    }

    return {

        showLoading : showLoading,
        hideLoading : hideLoading

    }

}();

export default JsLoading;